<template>
    <div class="con">
        <div v-if="loading" class="loading">
            <van-loading type="spinner" color="#e42127">加载中...</van-loading>
        </div>

        <div v-else-if="error" class="error-page">
            <div class="error-icon">
                <van-icon name="warning-o" size="80" color="#e42127" />
            </div>
            <div class="error-message">{{ error.msg }}</div>
        </div>

        <template v-else>
            <van-notice-bar v-if="config.notice" left-icon="volume-o" :text="config.notice" />

            <template v-for="(item, index) in config.items" :key="index">
                <div v-if="item.type === 'image'" @click="open">
                    <img :src="item.src" class="autoImg">
                </div>

                <div v-else-if="item.type === 'video'" class="video-wrapper">
                    <a :href="item.url" target="_blank" class="video-cover"
                       :style="{ background: item.videoBg || config.videoBg || '#2c3e70' }">
                    <div class="video-cover-inner">
                        <div class="video-text" :style="{ color: item.videoTextColor || config.videoTextColor || '#fff' }">
                            {{ item.videoTitle || config.videoTitle || config.title || '' }}
                        </div>
                        <div class="video-text" :style="{ color: item.videoTextColor || config.videoTextColor || '#fff' }">
                            {{ item.videoSubtitle || config.videoSubtitle || '' }}
                        </div>
                        <div class="video-text" :style="{ color: item.videoTextColor || config.videoTextColor || '#fff' }">
                            {{ item.videoPhone || config.videoPhone || config.phone || '' }}
                        </div>
                        <div class="video-play-btn">
                            <van-icon name="play" :color="item.videoTextColor || config.videoTextColor || '#fff'" />
                        </div>
                        <div class="video-highlight"
                             :style="{ color: item.videoHighlightColor || config.videoHighlightColor || '#e42127' }">
                            {{ item.videoHighlight || config.videoHighlight || '点击我观看宣传片' }}
                        </div>
                    </div>
                    </a>
                </div>

                <Bm v-else-if="item.type === 'form'"
                    :purpose_school="config.purpose_school"
                    :source="config.source"
                    :bg_color="config.bgColor"
                    :btn_color="config.btnColor">
                    <template v-slot:default>
                        <van-notice-bar left-icon="volume-o" :scrollable="false">
                            <swipe-item :list="config.recentSignups"></swipe-item>
                        </van-notice-bar>
                    </template>
                </Bm>
            </template>
        </template>

    </div>

    <BottomComponent v-if="!loading && !error"
                     :phone="config.phone"
                     :bg_color="config.bgColor"
                     :btn_color="config.btnColor"
                     :purpose_school="config.purpose_school"
                     :source="config.source"
                     :affim="config.affim"></BottomComponent>
    <Msg v-if="!loading && !error" :questions="config.questions" :affim="config.affim"></Msg>
</template>


<script>
import Msg from "@/components/Msg.vue";
import Bm from '@/components/Bm'
import BottomComponent from "@/components/BottomComponent.vue";
import SwipeItem from "@/components/SwipeItem.vue";
import open53 from "@/api/seviceBtn";
import {getConfig} from "@/api/config";
import {showToast} from 'vant';
import {reactive, ref, onMounted} from "vue";

function load53kfScript(url) {
    const existing = document.getElementById('_53kf_dynamic_script');
    if (existing) existing.remove();

    const s = document.createElement('script');
    s.id = '_53kf_dynamic_script';
    s.src = url;
    document.head.appendChild(s);
}

function loadTongjiScript(url) {
    if (!url) return;
    const existing = document.getElementById('_tongji_dynamic_script');
    if (existing) existing.remove();

    const scriptText = url.includes('hm.js') || url.includes('hm.baidu.com')
        ? `var _hmt = _hmt || [];(function(){var hm = document.createElement("script");hm.src = "${url}";var s = document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm, s);})();`
        : url;

    const s = document.createElement('script');
    s.id = '_tongji_dynamic_script';
    s.text = scriptText;
    document.head.appendChild(s);
}

function getSchoolFromUrl() {
    const hash = window.location.hash || '';
    const queryIdx = hash.indexOf('?');
    const queryStr = queryIdx >= 0 ? hash.substring(queryIdx + 1) : window.location.search.substring(1);
    const params = new URLSearchParams(queryStr);
    return params.get('sign') || '';
}

export default {
    name: 'Index',
    components: {SwipeItem, BottomComponent, Bm, Msg},
    setup() {
        const loading = ref(true);
        const error = ref(null);

        const config = reactive({
            title: '',
            notice: '',
            phone: '',
            kfJsUrl: '',
            tongjiJsUrl: '',
            questions: [],
            items: [],
            recentSignups: [],
            purpose_school: '',
            source: '',
            bgColor: '',
            btnColor: '',
            videoTitle: '',
            videoSubtitle: '',
            videoPhone: '',
            videoHighlight: '',
            videoBg: '',
            videoTextColor: '',
            videoHighlightColor: '',
            affim: ''
        });

        async function fetchData() {
            loading.value = true;
            error.value = null;
            const school = getSchoolFromUrl();
            try {
                const res = await getConfig({sign:school});
                Object.assign(config, res.data || {});

                if (config.title) {
                    document.title = config.title;
                }

                if (config.kfJsUrl) {
                    load53kfScript(config.kfJsUrl);
                }

                if (config.tongjiJsUrl) {
                    loadTongjiScript(config.tongjiJsUrl);
                }
            } catch (err) {
                error.value = err;
                if (err.msg) {
                    showToast(err.msg);
                }
            } finally {
                loading.value = false;
            }
        }

        onMounted(() => {
            fetchData();
        })

        function open() {
            open53(config.affim);
        }

        return {
            config,
            loading,
            error,
            open
        }
    }
}
</script>


<style>
.van-notice-bar {
    border-radius: var(--bs-border-radius);
    background: #eee !important;
}

.notice-swipe {
    height: 40px;
    line-height: 40px;
}

.con {
    padding-bottom: 50px;
}

@media (min-width: 750px) {
    .con {
        width: 750px;
        margin: 0 auto;
    }
}

@media (max-width: 750px) {
    .con {
        width: 100%;
        margin: 0 auto;
    }
}

.autoImg {
    width: 100%;
}

.video-wrapper {
    max-width: 750px;
    margin: 0 auto;
}

.video-cover {
    display: block;
    width: 100%;
    aspect-ratio: 25 / 12;
    text-decoration: none;
    position: relative;
}

.video-cover-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 12px;
    text-align: center;
}

.video-text {
    font-size: 5.2vw;
    font-weight: bold;
    line-height: 1.25;
    letter-spacing: 0.25vw;
    display: block;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 18vw;
    height: 18vw;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.35);
    z-index: 10;
}

.video-play-btn .van-icon {
    font-size: 9.36vw;
}

.video-highlight {
    font-size: 5.2vw;
    font-weight: bold;
    letter-spacing: 0.25vw;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (min-width: 750px) {
    .video-text {
        font-size: 35px;
        letter-spacing: 2px;
    }

    .video-play-btn {
        width: 97px;
        height: 97px;
    }

    .video-play-btn .van-icon {
        font-size: 50px;
    }

    .video-highlight {
        font-size: 35px;
        letter-spacing: 2px;
    }
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    padding: 20px;
}

.error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    text-align: center;
}

.error-icon {
    margin-bottom: 20px;
}

.error-message {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
}
</style>
